import { useEffect, useState } from 'react';
import useGraphQuery from '../../../../hooks/useGraphQuery';
import { QUERY_UPDATES } from '../../../../graphql/update';

export const useAlertPopover = () => {
  const { data, refetch, loading } = useGraphQuery(QUERY_UPDATES, {
    pollInterval: 3 * 60 * 1000, // Refetch the query every 3 minute
  });

  // ===================================
  const [open, setOpen] = useState(null);
  const [updatesList, setUpdatesList] = useState([]);
  const [showNotify, setShowNotify] = useState(0);

  // ===================================

  const handleTranslateData = (data) => {
    const translatedData = data.map((item) => item != null && ({
      ...item,
      isNew:
        item.IsDownloading !== null &&
        item.IsDownloading === false &&
        item.IsInstalled !== null &&
        item.IsInstalled === false,
    }));
    if(translatedData.length > 0) {
    const lastData = [translatedData[translatedData.length - 1]];
    return lastData;
    }
    return translatedData;
  };

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
    refetch();
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    if (data) {
      const translatedData = handleTranslateData(data.updates.all);
      setUpdatesList(translatedData);
    }
  }, [data]);

  useEffect(() => {
    if (updatesList) {
      const newUpdates = updatesList.filter((update) => update.isNew);
      setShowNotify(newUpdates.length);
    }
  }, [updatesList]);
  
  return {
    handleOpen,
    handleClose,
    open,
    updatesList,
    showNotify,
    setUpdatesList,
    loading,
  };
};
